<template>
	<v-sheet :tile="$vuetify.breakpoint.xs">
		<FunctionTitle title="" />
		<CommonFlame :title="'注文部品検索'" class="mt-2">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn color="primary" class="ml-2" @click="$router.push({ path: '/order_data' })">
					<i class="fas fa-undo"></i>
					注文データ一覧へ戻る
				</v-btn>
			</template>
			<v-form class="pa-2" ref="form" lazy-validation>
				<v-text-field
					v-if="form_type == 'ordered'"
					type="text"
					v-model="searchProductNumber"
					class="mt-2 mx-1"
					label="製造番号で検索"
					outlined
					dense
				/>

				<v-text-field
					v-model="searchWord"
					label="部品名で検索"
					hint="部品名を入力してください"
					class="mt-2 mx-1"
					outlined
					dense
				/>

				<v-text-field
					v-model="searchNumber"
					label="部品品番で検索"
					hint="品番を入力してください"
					class="mt-2 mx-1"
					outlined
					dense
				/>

				<v-row no-gutters align="center" justify="space-around">
					<v-btn
						v-if="form_type == 'ordered'"
						:disabled="!searchWord && !searchNumber && !searchProductNumber"
						class="ma-2 pa-2 mt-4"
						color="primary"
						@click="searchOrderedComponent()"
						><v-icon>mdi-magnify</v-icon>検索</v-btn
					>
					<v-btn
						v-if="form_type == 'all'"
						:disabled="!searchWord && !searchNumber && !searchProductNumber"
						class="ma-2 pa-2 mt-4"
						color="primary"
						@click="searchNotOrderedComponent()"
						><v-icon>mdi-magnify</v-icon>検索</v-btn
					>
				</v-row>
			</v-form>
			<v-row no-gutters justify="space-around"
				><v-btn
					class="ma-2 pa-2 pre-wrap height100p text-align-left"
					v-for="orderedProduct in searchedOrderedProducts"
					:key="orderedProduct.id"
					v-text="orderedProductInfo(orderedProduct)"
					@click="getOrderedProducts(orderedProduct)"
				></v-btn
			></v-row>
			<v-row no-gutters justify="space-around"
				><v-btn
					class="ma-2 pa-2 pre-wrap height100p text-align-left"
					v-for="order_component in order_components"
					:key="order_component.id"
					v-text="componentInfo(order_component)"
					@click="getComponent(order_component)"
				></v-btn
			></v-row>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import rules from "../../helper/rules"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			form: "",
			common: common,
			dialog: false,
			noResultFlag: false,
			searchProductNumber: "",
			searchWord: "",
			searchNumber: "",
			searchOrderNumber: "",
			searchedOrderComponents: [],
			selectedComponent: null,
			searchedOrderedProducts: [],
			order_components: [],
			type_options: {
				selectFormTypeDialogFlag: true,
				quotation_type: null,
				items: [
					{ type: "受注", value: "ordered" },
					{ type: "未受注", value: "yet" },
				],
			},
			form_type: "ordered",
		}
	},
	methods: {
		openDialog() {
			this.dialog = true
		},

		decision(type) {
			this.type_options.selectFormTypeDialogFlag = false
			this.form_type = type
		},

		searchOrderedComponent() {
			const headers = authenticate.setHeader()

			const params = {
				component_name_cont: this.searchWord,
				component_part_number_cont: this.searchNumber,
				ordered_product_product_number_cont: this.searchProductNumber,
			}
			axios
				.get(`/erp/v1/order_data/search_order_components`, {
					headers,
					params: { q: params },
				})
				.then((res) => {
					this.order_components = res.data.order_components
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		searchNotOrderedComponent() {
			const headers = authenticate.setHeader()

			const params = {
				component_name_cont: this.searchWord,
				component_part_number_cont: this.searchNumber,
				ordered_product_product_number_cont: this.searchProductNumber,
			}
			axios
				.get(`/erp/v1/order_data/search_components`, {
					headers,
					params: { q: params },
				})
				.then((res) => {
					this.order_components = res.data.order_components
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		fileShare(files) {
			this.uploadFiles = files
		},
		componentInfo(order_component) {
			return (
				"品番：" +
				order_component.component.part_number +
				"\n品名：" +
				order_component.component.name +
				"\nワイルドカード：" +
				this.common.returnMaruBatsu(order_component.component.wildcard) +
				"\n概要：" +
				order_component.component.description +
				"\n製造番号：" +
				order_component.ordered_product.product_number +
				"\n製品名：" +
				order_component.ordered_product.product.name
			)
		},

		resetData() {
			Object.assign(this.$data, initialState())
		},
	},
	watch: {
		statusIdsHash() {
			if (this.statusIdsHash != null) {
				let keys = Object.keys(this.statusIdsHash)
				keys.forEach((key) => {
					this.statusAndJapanese.push({
						text: this.statusIdsHash[key],
						value: key,
					})
				})
			}
		},
	},
	computed: {},
}
</script>

<style scoped lang="scss">
.fa-undo {
	margin-right: 4px;
}
</style>
